import { useSignal } from "@preact/signals-react";
import { useNavigate } from "react-router";

import Screen from "components/Meta/Screen";
import Board from "componentsv2/board/Board";
import { layout as layoutProspect } from "../layoutProspect";

function ViewProspect(props) {
  const navigate = useNavigate();
  const currentView = useSignal("list");
  const { config } = props;
  const _layoutProspect = layoutProspect(config);

  const handlereturn = () => {
    navigate(-1);
  };

  return (
    <Screen>
      <Board
        layout={_layoutProspect}
        returnFilter={handlereturn}
        currentView={currentView}
        showBackButton={true}
      />
    </Screen>
  );
}

export default ViewProspect;
